





















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { TanksApi, Tank } from '../../api';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import moment from 'moment';
import { Color, number } from '@amcharts/amcharts4/core';

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);

@Component({
	components: {},
	props: {
		tankId: Number,
		safeFillVolume: Number,
		maxVolume: Number,
	},
})
export default class TankChartAdmin extends Vue {
	public volumeRawDataFields = [
		{ key: 'date', label: 'Date' },
		{ key: 'data.capacitance', label: 'pF' },
		{ key: 'data.height', label: 'Height in mm' },
		{ key: 'data.val', label: 'L in Tank' },
		{ key: 'data.eventType', label: 'Event Type' },
	];
	public next = '';
	public prev = '';
	public savedDips = [];
	public rawData = [];
	public moment = moment;

	public graph;
	public tankId;
	public chart;
	public tempValueAxis;
	public offset = 0;
	public nDays = 7;
	public nDaysValues = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];
	public indicator;

	public form = {
		start: moment()
			.subtract(this.nDays, 'days')
			.format('DD-MM-YYYY')
			.toString(),
		end: moment()
			.format('DD-MM-YYYY')
			.toString(),
		shortcut: null,
	};

	public async reloadData(sortKey: string, prev = false) {
		try {
			const api = new TanksApi();
			const response = await api.getTankVolumeData(this.tankId, 'volume', {
				params: {
					perPage: 5,
					page: 1,
					sortKey,
					prev,
				},
			});
			this.rawData = response.data.data;
			this.next = response.data.links.nextSort;
			this.prev = response.data.links.currentSortKey;
		} catch (e) {
			console.log(e);
		}
	}

	public mounted() {
		this.reloadData();
	}

	// offset = current date - end date(offset is how far back it will look)
	// nDays = end date - start date (nDays is how many days back from the offset)
	public updateRange(start, end) {
		const a = moment(end, 'DD/MM/YYYY ').local();
		const b = moment(start, 'DD/MM/YYYY ').local();
		const c = moment().endOf('day');
		this.offset = c.diff(a, 'days');
		this.nDays = a.diff(b, 'days') + 1;
	}

	public updateForm() {
		if (this.form.end !== '') {
			this.updateRange(this.form.start, this.form.end);
			this.graphData();
		}
	}

	// am4core.disposeAllCharts();
	public beforeDestroy() {
		if (this.chart) {
			this.chart.dispose();
		}
	}

	@Watch('tankId', { immediate: true })
	public async graphData() {
		if (!this.tankId) {
			return;
		}
		try {
			//  getFuelGraphData(tankId: number, nDays?: number, series?: string, offset?: string
			const { data } = await new TanksApi().getFuelGraphData(
				parseInt(this.tankId, 10),
				this.nDays + 2,
				null,
				parseInt(this.offset, 10) - 1,
			);
			this.graph = data.data;
			this.loadChart();
		} catch (e) {
			console.log(e);
		} finally {
			// console.log('done');
		}
	}

	@Watch('offset', { immediate: false })
	public async updateOffset() {
		this.graphData();
	}

	@Watch('nDays', { immediate: false })
	public updateNDays() {
		this.graphData();
	}

	public async loadChart() {
		// Themes
		// am4core.useTheme(am4themes_animated);

		if (this.chart) {
			await this.chart.dispose();
		}

		// Create chart instance
		this.chart = am4core.create('chartdiv' + this.tankId, am4charts.XYChart);

		// Increase contrast by taking every second color
		this.chart.colors.step = 2;

		// this.chart = am4core.options.onlyShowOnViewport = true;

		// Create axes
		const dateAxis = this.chart.xAxes.push(new am4charts.DateAxis());
		dateAxis.renderer.minGridDistance = 50;
		dateAxis.baseInterval = { timeUnit: 'second', count: 1 };
		// dateAxis.dateFormats.setKey("day", "HH:mm/MMM dd");
		dateAxis.tooltipDateFormat = '[bold]dd-MM-yy, h:mm:ss a[/]';
		// dateAxis.dateFormats.setKey('minute', 'h:mm a');
		dateAxis.renderer.grid.template.location = 0;
		this.chart.scrollbarX = new am4core.Scrollbar();
		// this.chart.scrollbarY = new am4core.Scrollbar();

		dateAxis.renderer.axisFills.template.disabled = false;
		dateAxis.renderer.axisFills.template.fill = am4core.color('#D9D9D9');
		dateAxis.renderer.axisFills.template.fillOpacity = 0.3;

		dateAxis.min = parseInt(moment(this.form.start, 'DD-MM-YYYY').format('X')) * 1000;
		dateAxis.max =
			parseInt(
				moment(this.form.end, 'DD-MM-YYYY')
					.endOf('day')
					.format('X'),
			) * 1000;

		let dateFlag = true;
		let dayTemp = 0;
		dateAxis.fillRule = (dataItem: any) => {
			if (dayTemp !== dataItem.date.getDay()) {
				dayTemp = dataItem.date.getDay();
				dateFlag = !dateFlag;
			}
			dataItem.axisFill.visible = dateFlag;
		};
		// Add legend and cursor
		this.chart.legend = new am4charts.Legend();
		this.chart.cursor = new am4charts.XYCursor();

		const valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
		this.createSeries(valueAxis, false, 'height', 'Height', true, 'rectangle', 'orange');

		const volumeAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
		this.createSeries(volumeAxis, true, 'volume', 'Volume', false, 'circle', '#aaa');

		const max =
			(this.safeFillVolume > this.maxVolume ? this.safeFillVolume : this.maxVolume) * 1.05;
		volumeAxis.min = 0;
		volumeAxis.max = max;

		const safeFillAxis = this.chart.yAxes.push(new am4charts.ValueAxis());

		this.addHorizontalLine(
			volumeAxis,
			this.safeFillVolume,
			'#00215A',
			'Safe Fill Volume',
			'2 4 8 2 ',
		);
		this.addHorizontalLine(
			volumeAxis,
			this.maxVolume * 0.97,
			'#dc3545',
			`Max Alert Volume ${Math.round(this.maxVolume * 0.97)}L`,
			'2 4',
			true,
		);

		// this.chart.cursor.behavior = 'zoomXY';
		this.chart.cursor.xAxis = dateAxis;

		dateAxis.dateFormatter = new am4core.DateFormatter();
		dateAxis.dateFormatter.dateFormat = 'MM-dd';
	}

	// Create series
	public createSeries(
		valueAxis: am4charts.ValueAxis,
		fillArea: boolean,
		field: string,
		name: string,
		opposite: boolean,
		shape: string,
		lineColor?: string,
		strokeWidth?: number,
	) {
		valueAxis.min = 0;
		// if (field === 'vatTemp' || field === 'inletTemp') {
		//  valueAxis.max = 80;
		// }

		const series = this.chart.series.push(new am4charts.LineSeries());
		series.dataFields.valueY = field;
		series.dataFields.dateX = 'date';
		series.strokeWidth = strokeWidth || 2;

		series.yAxis = valueAxis;

		series.connect = false;
		series.autoGapCount = 3600 * 12;

		series.name = name;
		series.tooltipText = '{name}: [bold]{valueY}[/]{details}';

		// does not draw line of periods >8hours with no data
		// series.autoGapCount = 28800;
		// series.connect = false;

		const skipped = 0;

		if (fillArea) {
			series.fillOpacity = fillArea ? 0.3 : 0;
			if (lineColor) {
				series.fill = lineColor;
			}
		}

		if (lineColor) {
			series.stroke = am4core.color(lineColor);
			series.fill = lineColor;
		}

		const chartData = [];

		for (const row in this.graph[field]) {
			if (this.graph[field].hasOwnProperty(row)) {
				const newDate = new Date(this.graph[field][row].date);
				let label = '';
				let size = 0;
				const fill = am4core.color('#fff');
				if (this.graph[field][row].label) {
					size = this.graph[field][row].size;
					label = this.graph[field][row].label;
					label = label.charAt(0).toUpperCase() + label.slice(1);
				}

				/*to opitimse graphs skip consecutive values that are the same
          when skipping hold last datapoint that was skipped and add before
          the value changes to accuratly reflect length of time the values were
          the same
        */

				let details;
				let detValue = 0;
				if (label) {
					if (this.graph.withdrawal != null) {
						const withdrawal = this.graph.withdrawal.find(
							entry => entry.date === this.graph[field][row].date,
						);
						if (withdrawal != null) {
							details = ` (Withdrawal: ${withdrawal.value}L)`;
							detValue = withdrawal.value;
						}
					}
					if (this.graph.refill != null) {
						const refill = this.graph.refill.find(
							entry => entry.date === this.graph[field][row].date,
						);
						if (refill) {
							details = ` (Refill: ${refill.value}L)`;
							detValue = refill.value;
						}
					}
				}

				const value = this.graph[field][row].value;
				const dataPoint = {
					date: newDate,
					label: label ? `${label} (${detValue}L)` : '',
					size,
					[field]: value,
					fill,
					details,
				};

				chartData.push(dataPoint);
			}
		}

		if (this.graph[field].length < 1) {
			this.showIndicator(field);
		}

		series.data = chartData;

		const interfaceColors = new am4core.InterfaceColorSet();

		// labels
		if (field === 'volume' || field === 'height') {
			const bullet = series.bullets.push(new am4charts.CircleBullet());
			// bullet.circle.fill = am4core.color('#fff');
			bullet.circle.strokeWidth = 2;
			bullet.circle.propertyFields.radius = 'size';
			bullet.circle.propertyFields.fill = 'fill';
			bullet.tooltipText = '{name}: [bold]{valueY}[/]{details}';

			const seriesLabel = series.bullets.push(new am4charts.LabelBullet());
			seriesLabel.label.text = '{label}';
			seriesLabel.label.horizontalCenter = 'left';
			seriesLabel.label.fontSize = 11;
			seriesLabel.label.dx = 5;
		}

		valueAxis.renderer.line.strokeOpacity = 0.1;
		valueAxis.renderer.line.strokeWidth = 2;
		valueAxis.renderer.labels.template.fill = series.stroke;
		if (field === 'volume') {
			valueAxis.renderer.opposite = false;
		} else {
			valueAxis.renderer.opposite = true;
		}

		valueAxis.renderer.grid.template.disabled = true;
	}

	public showIndicator(field: string) {
		this.indicator = this.chart.tooltipContainer.createChild(am4core.Container);
		this.indicator.background.fill = am4core.color('#fff');
		this.indicator.background.fillOpacity = 0.8;
		this.indicator.width = am4core.percent(100);
		this.indicator.height = am4core.percent(100);
		const indicatorLabel = this.indicator.createChild(am4core.Label);
		indicatorLabel.text = 'No data for this date range...';
		indicatorLabel.align = 'center';
		indicatorLabel.valign = 'middle';
		indicatorLabel.fontSize = 20;
	}

	private addHorizontalLine(
		valueAxis: am4charts.ValueAxis<am4charts.AxisRenderer>,
		yValue: number,
		colorHexCode: string,
		label: string,
		dashArray: string,
		rightAlign: boolean = false,
	): void {
		const range = valueAxis.axisRanges.create();
		range.value = yValue;
		range.label.text = label;
		range.label.fontSize = 10;
		range.grid.stroke = am4core.color(colorHexCode);
		range.grid.strokeOpacity = 0.5;
		range.grid.strokeWidth = 2;
		range.label.inside = true;
		range.label.align = rightAlign ? 'right' : 'left';
		range.label.fill = range.grid.stroke;
		range.grid.strokeDasharray = dashArray;
	}
}
